module.exports = __webpack_public_path__ + "img/tutorial00.06f1dbcc.svg";